import { render, staticRenderFns } from "./OtherGiftModal.vue?vue&type=template&id=35100f1a"
import script from "./OtherGiftModal.vue?vue&type=script&lang=js"
export * from "./OtherGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports